import { AuthLayout } from 'src/features/auth/components';
import { ResetPasswordForm } from 'src/features/auth/components/ResetPasswordForm';

const ResetPassword = () => {
    return (
        <AuthLayout>
            <ResetPasswordForm />
        </AuthLayout>
    );
};

export { ResetPassword };
